import { Link } from 'react-router-dom';
import { Mail, MapPin, Zap } from 'lucide-react';

const FOOTER_LINKS = {
  Products: [
    { to: '/products', label: 'All Products' },
    { to: '/products?power=<200', label: 'BESS < 200 kW' },
    { to: '/products?power=200-500', label: 'BESS 200\u2013500 kW' },
    { to: '/products?power=500+', label: 'BESS 500+ kW' },
  ],
  Solutions: [
    { to: '/solutions/dg-replacement', label: 'DG Replacement' },
    { to: '/solutions/solar-storage', label: 'Solar + Storage' },
    { to: '/solutions', label: 'Peak Shaving' },
    { to: '/solutions/ev-charging', label: 'EV Charging' },
  ],
  Company: [
    { to: '/about', label: 'About' },
    { to: '/case-studies', label: 'Case Studies' },
    { to: '/contact', label: 'Contact' },
  ],
  Resources: [
    { to: '/calculator', label: 'Savings Calculator' },
    { to: '/case-studies/uru', label: 'Uru Brewpark' },
    { to: '/case-studies/tfl-betul', label: 'TFL Betul' },
    { to: '/contact', label: 'FAQ' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-[#0a0f1a] text-white" data-testid="site-footer">
      <div className="voltide-container py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 lg:gap-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#0061DD] rounded-lg flex items-center justify-center">
                <Zap className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-bold tracking-tight">Voltide</span>
            </Link>
            <p className="text-sm text-stone-400 leading-relaxed mb-4">
              Clean, reliable battery energy storage systems. Replacing diesel generators with silent, zero-emission power.
            </p>
            <div className="space-y-2">
              <a href="mailto:info@voltide.energy" className="flex items-center gap-2 text-sm text-stone-400 hover:text-[#0061DD] transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4" /> info@voltide.energy
              </a>
              <div className="flex items-start gap-2 text-sm text-stone-400">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>WeWork Latitude, Bellary Road, Bengaluru 560024</span>
              </div>
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-sm font-semibold text-stone-300 uppercase tracking-wider mb-4">{category}</h4>
              <ul className="space-y-2.5">
                {links.map(link => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-stone-400 hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-500">&copy; 2025 Voltide Solutions Pvt. Ltd. All rights reserved.</p>
          <p className="text-xs text-stone-600">CIN: U38300KA2024PTC193948</p>
        </div>
      </div>
    </footer>
  );
}
